import { GenericService } from '../generic.service';
import { OrderConfigurationType } from '@/models';

export class MeniconOrderConfigurationTypesService extends GenericService<OrderConfigurationType> {
  endpoint = 'menicon/v1/order-configuration-types';
}
